import React from 'react';
import projects from '../consts/projects';
import websites from '../consts/websites';
import techs from '../consts/techs';
import media from '../consts/media';

function mapLinks(links) {
  function mapLink(link) {
    let href = links[link].startsWith("http")
      ? links[link]
      : "https://" + (link === "live" ? "" : websites[link] || "") + links[link];

    if (link === "figma" && !href.startsWith("http")) href = `https://figma.com/community/file/${links[link]}`;
    if (link === "github" && links[link].startsWith("/")) href = media.github + links[link];

    const className = link === "cached" ? "button__secondary" : "";
    const name = `${link[0].toUpperCase()}${link.slice(1)}`;

    return (
      <a key={link} href={href} className={`button ${className}`} target="_blank" rel="noopener noreferrer">
        {name} {"=>"}
      </a>
    );
  }

  return Object.keys(links).map(mapLink);
}

const Project = ({ id, t }) => {
  const project = projects.find(p => p.id === id);
  if (!project) return null;

  const { hasImage, techs: projectTech, links } = project;

  return (
    <div className="project">
      {hasImage && (
        <img
          src={`/images/projects/${id}.${project.imgExtension || 'webp'}`}
          alt={t[id]?.name || id}
          className="project__image"
        />
      )}

      <ul className="project__techs">
        {projectTech.map(tech => (
          <li key={tech} className="project__tech">{techs[tech]}</li>
        ))}
      </ul>

      <div className="project__content">
        <div className="project__name">{t[id]?.name || id}</div>
        <div className="project__description">{t[id]?.description || ""}</div>
        <div className="project__links">{mapLinks(links)}</div>
      </div>
    </div>
  );
};

export default Project;
